// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__dI-c4","productName":"Table_productName__2Ile9"};